

<!--
@if(data()){
  <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
    <div class="spike-card mb-4" style="border: 1px solid var(--p-primary-active-color);border-left: 4px solid var(--p-primary-active-color);">
        <div class="font-bold text-xl mb-4">Monitoraggio costi</div>
      <spike-positions-cost [form]="form" ></spike-positions-cost>
    </div>
  </div>
}
-->
<spike-editable-panel 
  title="Dettaglio lavorazione"
  [(isEditing)]="formView"
  (onSave)="save()"
  [isReadonly]="isReadOnly()"
  (onCancel)="formView.set(false)">

  <div class="tab-bar-container">
      <div class="tab-bar">
          <div class="tab-item" [class.active]="page() === 0" (click)="page.set(0)" >Materie prime</div>
          <div class="tab-item"  [class.active]="page() === 1" (click)="page.set(1)">Utensili</div>
          <div class="tab-item"  [class.active]="page() === 2" (click)="page.set(2)">{{showConsuntive() ? 'Consuntivo' : 'Operazioni'}}</div>
      </div>
  </div>
  <div class="viewport">
    <div class="strip" [style.transform]="'translateX(' + (page() * -100) + '%)'">
      <div class="slide">
        @if(materialsReady() && page() === 0){
        <spike-position-materials-form 
          [workingPhase]="workingPhase()"
          [showRequest]="canRequest()"
          [form]="materialsArray"
          (addRow)="addMaterialRow()"
          (deleteRow)="deleteMaterialRow($event)"
          (calculateTotal)="changeTotal('equipmentCost', $event)"
          (createRequest)="createRequest($event)">
        </spike-position-materials-form>
        }
      </div>
      <div class="slide">
      @if(toolsReady() && page() === 1){
        <spike-position-tools-form
          [workingPhase]="workingPhase()"
          [showRequest]="canRequest()"
          [form]="toolsArray"
          (addRow)="addToolRow()"
          (deleteRow)="deleteToolRow($event)"
          (calculateTotal)="changeTotal('toolCost', $event)"
          (createRequest)="createRequest($event)">
        </spike-position-tools-form>
      }
      </div>

        <div class="slide">
        @if(operationsReady() && page() === 2){
          <spike-position-operations-form 
            [workingPhase]="workingPhase()"
            [form]="operationsArray"
            [isConsuntivo]="showConsuntive()"
            (addExternalRow)="addOperationExternalRow()"
            (addInternalRow)="addOperationInternalRow()"
            (deleteRow)="deleteOperationRow($event)"
            (calculateInternalTotal)="changeTotal('productionCost', $event)"
            (calculateExternalTotal)="changeTotal('externalCost', $event)">
          </spike-position-operations-form>
        }
      </div>      
    </div>
  </div>
</spike-editable-panel>


@if(data() && data().equipmentRequests ){
  <div class="mb-2" style="font-weight: bold;">Approvvigionamenti</div>

  @if(data()!.equipmentRequests!.length > 0){
<div class="spike-table-card mb-4">
  <spike-equipment-requests-table 
    [minimal]="true" 
    [items]="data()!.equipmentRequests!"
    [sorting]="sorting()"
    (onSelect)="onRequestSelected($event)" 
    (onDelete)="onRequestDeleted($event)" >
  </spike-equipment-requests-table>
</div>
}@else {
  <div class="spike-card mb-4">
  <spike-no-result message='Nessun approvvigionamento' textAlign='left'></spike-no-result>
  </div>
}

}

@if(isRequestDialogVisible() && selectedRequest()){
    <spike-create-equipment-request-side-panel
      [readonly]="!canEditRequest()" 
      [data]="selectedRequest()!" 
      [(isDialogVisible)]="isRequestDialogVisible" 
      (onClose)="isRequestDialogVisible.set(false)" 
      (onSave)="onUpdate()">
    </spike-create-equipment-request-side-panel>
}

